import { render, staticRenderFns } from "./view_CrocodileEnglish.vue?vue&type=template&id=71da3c8e&"
import script from "./view_CrocodileEnglish.vue?vue&type=script&lang=js&"
export * from "./view_CrocodileEnglish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports